/**
 * @deprecated
 * @returns {boolean}
 */
export const isPortrait = () => {
  // https://mui.com/material-ui/react-use-media-query/#migrating-from-withwidth
  // isWidthDown('xs', width);
  return window.matchMedia('(max-width: 600px)').matches;
};

export const isAndroid = () => /android/i.test(window.navigator.userAgent);

export const isMobileDevice = () =>
  !!window.navigator.userAgent.match(/iphone|android/gi);
